// src/dayjs.config.ts
// Importar los locales que uses
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import 'dayjs/locale/en';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

// --- Plugins ---
dayjs.extend(localizedFormat);

// --- Formato por defecto ---
// Usamos "L" porque se adapta al locale activo (ej: 05/09/2025 en ES, 09/05/2025 en EN)
const DEFAULT_FORMAT = 'L';

function defaultFormatPlugin(_: unknown, DayjsClass: any) {
  const oldFormat = DayjsClass.prototype.format;

  DayjsClass.prototype.format = function (formatStr?: string) {
    return oldFormat.bind(this)(formatStr || DEFAULT_FORMAT);
  };
}

dayjs.extend(defaultFormatPlugin);

// --- Locale por defecto ---
dayjs.locale('es');

// --- Exportaciones ---

export function setDayjsLocale(lang: string) {
  dayjs.locale(lang);
}
